import "./_asset-name-with-logo-and-unit.scss";

import classNames from "classnames";

import AssetLogo from "../../logo/AssetLogo";
import {combineAssetUnitAndId} from "../../util/assetUtils";
import AssetName from "../AssetName";
import {AssetListItemData} from "../../util/assetModels";

interface AssetNameWithLogoAndUnitProps {
  asset: Pick<AssetListItemData, "name" | "unit_name" | "id" | "clawback_address">;
  customClassName?: string;
  nameCharLimit?: number;
  testid?: string;
}

function AssetNameWithLogoAndUnit({
  testid,
  asset,
  customClassName,
  nameCharLimit
}: AssetNameWithLogoAndUnitProps) {
  return (
    <div
      className={classNames(
        "is-vertically-centered",
        "asset-name-with-logo-and-unit",
        customClassName
      )}>
      <AssetLogo asset={asset} />

      <div className={"asset-name-with-logo-and-unit__name-and-unit"}>
        <AssetName asset={asset} charLimit={nameCharLimit} />

        <p
          data-testid={`${testid}.asset-unit-and-id`}
          className={
            "asset-name-with-logo-and-unit__asset-unit-and-id typography--body color--text-gray"
          }>
          {combineAssetUnitAndId(asset)}
        </p>
      </div>
    </div>
  );
}

export default AssetNameWithLogoAndUnit;
